import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DragPart } from '../../interaction/movement/drag-and-resize/drag-part';
import { ITimeBlockComponentItem } from '../../types/time-block-component-item-types';
import * as svgIcons from '@progress/kendo-svg-icons';
import { TimeBlockModel } from '../../../../../../core/models/timeblock/time-block.model';
import { CalendarViews } from '../../../../calendar-types';

@Component({
  selector: 'app-drag-edge-template',
  templateUrl: './drag-edge-template.component.html',
  standalone: false,
})
export class DragEdgeTemplateComponent {
  @ViewChild('dragEdge') public dragEdge: ElementRef<HTMLElement>;
  @Input() public dragPart: DragPart;
  @Input() public calendarView: CalendarViews;
  @Input() public timeBlockComponentItem: ITimeBlockComponentItem;
  @Input() public model: TimeBlockModel;
  public CalendarView = CalendarViews;
  public handleDragIcon = svgIcons.handleDragIcon;
}
